export class Reporte {
  NReporte: any;
  SpName: string;
}
